<template>
  <h1>Lisää anturi</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>